import React from 'react';
import { Mode } from '@src/constants';
import { useTranslation } from 'react-i18next';

import LocationContainer from './ILocationContainer';
import EquipmentContainer from './IEquipmentContainer';
import ContactListContainer from './IContactListContainer';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import IChemicalContainer from './ChemicalInformation/IChemicalContainer';
import { Grid } from 'semantic-ui-react';
import IOtherContainer from './IOtherContainer';
import IDescriptionContainer from './IDescriptionContainer';

type Props = {
  values: any;
  errors: any;
  setFieldValue: (arg1: string, arg2: string) => void;
  isHistory: boolean;
  initialData: any;
  mode: Mode;
  entityTypeProp: string;
  setOverridePersonState: (arg: boolean) => void;
  validateOnChange: boolean;
  disabled: boolean;
};

const IGeneralInformationContainer = ({
  values,
  errors,
  setFieldValue,
  isHistory,
  initialData,
  mode,
  entityTypeProp,
  setOverridePersonState,
  validateOnChange,
  disabled,
}: Props) => {
  const { t } = useTranslation();
  return (
    <AccordionWrapper
      collapsed={false}
      accordionTitle={t('inventory.details.page.general.information.container.title')}
      className="containerReducedWhiteSpace"
      render={() => (
        <>
          <Grid stackable doubling columns={2}>
            <Grid.Column>
              <LocationContainer
                values={values}
                initialData={initialData}
                errors={errors}
                setFieldValue={setFieldValue}
                disabled={disabled}
                mode={mode}
                entityTypeProp={entityTypeProp}
              />
              <IDescriptionContainer
                values={values}
                errors={errors}
                setFieldValue={setFieldValue}
                disabled={disabled}
              />
              <EquipmentContainer
                values={values}
                errors={errors}
                setFieldValue={setFieldValue}
                disabled={disabled}
              />
            </Grid.Column>
            <Grid.Column>
              {
                <ContactListContainer
                  values={values}
                  initialData={initialData}
                  errors={errors}
                  mode={mode}
                  setOverridePersonState={setOverridePersonState}
                  validateOnChange={validateOnChange}
                  disabled={disabled}
                  setFieldValue={setFieldValue}
                />
              }
            </Grid.Column>
            <Grid.Column width={16}>
              {
                <IChemicalContainer
                  values={values}
                  initialData={initialData}
                  errors={errors}
                  setFieldValue={setFieldValue}
                  disabled={disabled}
                />
              }
            </Grid.Column>
            <Grid.Column width={16}>
              {
                <IOtherContainer
                  values={values}
                  isHistory={isHistory}
                  errors={errors}
                  setFieldValue={setFieldValue}
                  disabled={disabled}
                />
              }
            </Grid.Column>
          </Grid>
        </>
      )}
    />
  );
};

export default IGeneralInformationContainer;
